import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/** Resolve the canonical profile URL for a user/org card. */
export function profileHref(card) {
  if (!card || !card.slug) return null;
  const t = card.target_type || card.profile_type || card.type;
  if (t === "business") return `/b/${card.slug}`;
  if (t === "capital") return `/capital/${card.slug}`;
  return `/p/${card.slug}`;
}

/** Renders a display name that links to the author's profile (plain text if no slug). */
export function AuthorLink({ card, className, testId, fallback = "Member", children }) {
  const name = children ?? (card && card.display_name) ?? fallback;
  const href = profileHref(card);
  if (!href) return <span className={className}>{name}</span>;
  return (
    <Link to={href} onClick={(e) => e.stopPropagation()} className={cn("hover:underline", className)} data-testid={testId}>
      {name}
    </Link>
  );
}

/** Wraps an avatar so it links to the author's profile (returns children unchanged if no slug). */
export function AuthorAvatar({ card, className, children }) {
  const href = profileHref(card);
  if (!href) return children;
  return (
    <Link to={href} onClick={(e) => e.stopPropagation()} className={cn("shrink-0", className)} aria-label={card?.display_name || "Profile"}>
      {children}
    </Link>
  );
}
